import { SectionName } from 'types/types'

export enum ActionType {
  SET_BLOCK_COLLAPSED,
  SET_NEED_TO_SAVE_BLOCK,
  SET_NAVBAR_COLOR,
}

export enum NavbarColor {
  transparent = 'transparent',
  corp = '#990099',
}

export interface SET_BLOCK_COLLAPSED {
  type: ActionType.SET_BLOCK_COLLAPSED
  payload: {
    block: SectionName
  }
}

export interface SET_NEED_TO_SAVE_BLOCK {
  type: ActionType.SET_NEED_TO_SAVE_BLOCK
  payload: {
    needToSaveBlock: SectionName | ''
  }
}

export interface SET_NAVBAR_COLOR {
  type: ActionType.SET_NAVBAR_COLOR
  payload: {
    navbarColor: NavbarColor
  }
}

export type AdminMenuUiActions = SET_BLOCK_COLLAPSED | SET_NEED_TO_SAVE_BLOCK | SET_NAVBAR_COLOR
